import { NgIf } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { CodeAndName } from '@lx/shared/types';
import { Company, CompanyEnum } from '../../models/company.model';
import { PriceListGeneralFeeProduct } from '../../models/pricelist-general-fee.model';
import { PriceListNote } from '../../models/priceslist-note.model';
import { Note, ProductsWithPriceAndNoteLabels, ProductWithPriceAndAdditionalInfo } from '../../models/types';
import { NotesService } from '../../services/notes.service';
import { SubjectEnum } from '../../utils/notes.utils';
import { NotesComponent } from '../notes/notes.component';
import { PriceAndNoteTableComponent } from '../price-and-note-table/price-and-note-table.component';
import { TableHeaderComponent } from '../table-header/table-header.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-premium-activities',
  imports: [PriceAndNoteTableComponent, TableHeaderComponent, NgIf, NotesComponent],
  templateUrl: './premium-activities.component.html',
  styleUrls: ['./premium-activities.component.scss'],
})
export class PremiumActivitiesComponent implements OnInit {
  @Input() company: Company = CompanyEnum.ALP;
  @Input() currency: CodeAndName | undefined;
  @Input() premiumActivities: PriceListGeneralFeeProduct[] | undefined;
  @Input() premiumActivitiesNotes: PriceListNote[] | undefined;

  notes: Note[] | undefined;
  notationMarks: Record<string, string> | undefined;

  dataSource: ProductWithPriceAndAdditionalInfo[] = [];
  columnLabels: ProductsWithPriceAndNoteLabels = {
    product: 'Activity',
    price: 'Price',
    notes: 'Notes',
  };

  private readonly notesService = inject(NotesService);

  ngOnInit(): void {
    this.dataSource = this.premiumActivities?.map(({ name, additionalInfo, price }) => ({
      name,
      price: price?.price,
      additionalInfo,
    }));

    const premiumActivities = this.notesService.getNotes(this.premiumActivitiesNotes, SubjectEnum.PREMIUM_ACTIVITIES);
    if (premiumActivities) {
      [this.notes, this.notationMarks] = premiumActivities;
    }
  }
}
